<template>
  <v-expand-transition>
    <div v-if="isBrandMenu" class="brands-menu">
      <div class="app-container d-flex">
        <div
          v-for="(column, i) in items"
          :key="`bc-${i}`"
          class="brands-menu_column"
        >
          <div
            v-for="(group, letter) in column"
            :key="`bl-${letter}`"
            class="brands-menu_group"
          >
            <span class="brands-menu_letter">{{ letter }}</span>
            <div class="brands-menu__list">
              <template v-for="(brand, i) in group">
                <a
                  v-if="brand.isBold"
                  :key="`b-${i}`"
                  :href="brand.link"
                  class="brands-menu_link"
                  ><b>{{ brand.title }}</b></a
                >
              </template>

              <template v-for="(brand, i) in group">
                <a
                  v-if="!brand.isBold"
                  :key="`b-${i}`"
                  :href="brand.link"
                  class="brands-menu_link"
                  >{{ brand.title }}</a
                >
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-expand-transition>
</template>

<script>
export default {
  name: "BrandsMenu",
  props: {
    items: {
      type: [Array, null],
      default: () => []
    },
    isBrandMenu: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "BrandsMenu";
</style>
